import store from '../store';
export function GetTimeTracker() {
  const tamTracker = store.getState()?.app?.entities?.features?.tamTracker?.data;
  return tamTracker;
}
